import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddEquipmentPopupComponent } from '../../components/add-equipment-popup/add-equipment-popup.component'
import { EquipmentContent, EquipmentFilters, EquipmentResponse } from 'src/app/domains/equipment/models';
import { EquipmentService } from 'src/app/domains/equipment/services';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { take } from 'rxjs/operators';
import { Company } from 'src/app/domains/companies/models';

const PAGE_SIZE = 30;

@Component({
  selector: 'gdp-telephony-main',
  templateUrl: './telephony-main.component.html',
  styleUrls: ['./telephony-table.component.scss']
})
export class TelephonyMainComponent implements OnInit {
  public filters: EquipmentFilters = null;
  public pageSize: number;
  public loadingLines: Array<number>;
  public page: number = 0;
  public equipmentList: Array<any> = [];
  public loading: boolean = false;
  public sameFilters: boolean = true;
  @Input() company: Company;
  public limitedAvailableFilters = ['model','alphaname','pbxId'];
  public showMacAddressAndIpui = true;

  public pagination = {
    page: 0,
    empty: true,
    totalPages: 0
  };

  constructor(
    private modalService: NgbModal,
    private equipmentService: EquipmentService,
    private notification: NotificationService
    ) {}

  ngOnInit() {
    this.pageSize = PAGE_SIZE;
    this.filters = {
      macAddress: null,
      alphaname: null,
      model: null,
      pbxId: null,
      ipui: null
    };
    this.getEquipment();
  }

  filterChanged(event:EquipmentFilters) {
    if (this.areNotEmptyFilters(event)) {
        this.filters = event;
      } else {
        this.filters = null;
      }
    this.sameFilters = false;
    this.getEquipment();
  }

  areNotEmptyFilters(event) {
    return event.macAddress !== '' ||
    event.alphaname !== '' ||
    event.model !== '' ||
    event.pbxId !== '';
  }

  selectPageSize(event) {
    this.pageSize = event;
    this.pagination.page = 0;
    this.getEquipment();
  }

  changeCurrentPage(event) {
    this.pagination = {
      page: event,
      empty: this.equipmentList.length === 0,
      totalPages: this.pagination.totalPages
    }
    this.getEquipment();
  }

  setLoadingLines() {
    this.loadingLines = [];
    for(var i = 1; i <= this.pageSize; i++) {
      this.loadingLines.push(i);
    }
  }

  getEquipment() {
    this.setLoadingLines();
    this.loading = true;
    if(this.filters && this.filters.macAddress) {
      this.equipmentService
        .getEquipmentByMacAddress(this.filters.macAddress, [
          {
            status: 404,
            message: 'equipment.filters.errors.macAddress-not-found'
          },
          {
            status: 500,
            message: 'equipment.filters.errors.macAddress-invalid'
          }
        ])
        .subscribe(
          (res: EquipmentContent) => {
            this.equipmentList = [res];
            this.pagination.totalPages = 1;
            this.loading = false;
          }, () => {
            this.equipmentList = [];
            this.pagination.totalPages = 1;
            this.pagination.page = 0;
            this.loading = false;
          }
        );
    } else if(this.filters && this.filters.ipui) {
      this.equipmentService
        .getEquipmentByIpui(this.filters.ipui, [
          {
            status: 404,
            message: 'equipment.filters.errors.ipui-not-found',
          },
          {
            status: 500,
            message: 'equipment.filters.errors.ipui-invalid'
          }
        ])
        .subscribe(
          (res: EquipmentContent) => {
            this.equipmentList = [res];
            this.pagination.totalPages = 1;
            this.loading = false;
          }, () => {
            this.equipmentList = [];
            this.pagination.totalPages = 1;
            this.pagination.page = 0;
            this.loading = false;
          }
        );
    } else {
      if (this.filters && !this.sameFilters) {
        this.pagination.page = 0;
      } else {
        this.pagination.page = this.pagination.page;
      }
      this.sameFilters = true;
      this.equipmentService
        .getEquipment(
          this.pagination.page,
          this.pageSize,
          this.filters
        )
        .subscribe((res: EquipmentResponse) => {
        this.equipmentList = res.content;
        this.equipmentList.length !== 0 ? this.pagination.totalPages = res.totalPages : this.pagination.totalPages = 1;
        this.loading = false;
      }, () => {
        this.loading = false;
      });
    }
  }

  openAddEquipmentPopup() {
    const modal = this.modalService.open(AddEquipmentPopupComponent, {
      size: 'lg'
    });
    modal.componentInstance.onAddEquipment.pipe(take(1)).subscribe(() => {
      this.getEquipment();
    });
  }
}
